import Multiselect from 'multiselect-react-dropdown';
import { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { toast } from 'react-toastify';
import { UI_ELEMENTS_TEXTUAL_KEYS, UI_MODULES } from '../../../core/constants/common';
import PartnerService from '../../../core/service/PartnerService';

const PartnerUIConfig = ({ t }) => {

	const [formData, setFormData] = useState({
		hiddenModules: [],
		texts: {
			dashboard: '',
			footer: '',
			privacyPolicy: '',
			termsAndConditions: '',
			esgAI: '',
			appTitle: '',
			homePageURL: '',
			partnerLogoURL: '',
			copilotHelp: ''
		}
	});
	const [partners, setPartners] = useState([]);
	const [selectedPartner, setSelectedPartner] = useState('');

	useEffect(() => {
		PartnerService.getAllPartners().then(res => {
			if (res.status !== 200) return;

			setPartners(res.data ?? []);
		}).catch(err => {});
	}, []);

	useEffect(() => {
		if (!selectedPartner) return;

		PartnerService.getPartnerSpecificUIConfig(selectedPartner).then(res => {
			if (res.status !== 200) return;

			if (res.data) {
				setFormData(res.data);
			} else {
				setFormData({
					hiddenModules: [],
					texts: {
						dashboard: '',
						footer: '',
						privacyPolicy: '',
						termsAndConditions: '',
						esgAI: '',
						appTitle: '',
						homePageURL: '',
						partnerLogoURL: '',
						copilotHelp: ''
					}
				});
			}
		}).catch(err => {});
	}, [selectedPartner]);

	const onSave = () => {
		if (!selectedPartner) return;

		PartnerService.saveUIConfig(selectedPartner, formData).then(res => {
			if (res.status !== 200) return;

			toast.success("Success", {
				position: toast.POSITION.TOP_RIGHT,
			});
		}).catch(err => {

		});
	};

	const onSelectDeSelectModule = (selectedItem) => {
		const modules = [...formData.hiddenModules];
		const index = formData.hiddenModules.indexOf(selectedItem.id);
		if (index >= 0) {
			modules.splice(index, 1);
		} else {
			modules.push(selectedItem.id);
		}
		setFormData({
			...formData,
			hiddenModules: modules
		});
	};

	const getSelectedHiddenModules = () => {
		const modules = [];
		formData.hiddenModules?.forEach(id => {
			const m = UI_MODULES.find(u => u.id === id);
			modules.push(m);
		})
		return modules;
	}

	return (
		<>
			<section>
				<div className="Main_body">
					<div className="Company_formBox col-lg-6">
						<div className="List_header">
							<h5 className="MH">{t('PartnerUIConfig.label')}</h5>
						</div>
						<Form noValidate>
							<div className="mb-4 row mx-0">
								<div className="col-lg-12 p-2">
									<label className="mb-2">Partner</label> &nbsp;*
									<select
										className="form-select"
										required
										onChange={(e) => setSelectedPartner(e.target.value)}
										value={selectedPartner}>
										<option value="" disabled hidden>
											{t("Select.label")}
										</option>
										{
											partners?.map((p) => (
												<option value={p.partnerId} key={p.partnerId}>{p.name}</option>
											))
										}
									</select>
								</div>
								<div className="col-lg-12 p-2">
									<label className="mb-1">Hidden Modules</label>
									<Multiselect
										key='hiddenModuleKey'
										options={UI_MODULES}
										selectedValues={getSelectedHiddenModules()}
										onSelect={(selectedList, selectedItem) => {
											onSelectDeSelectModule(selectedItem);
										}}
										onRemove={(selectedList, selectedItem) => {
											onSelectDeSelectModule(selectedItem);
										}}
										displayValue="text"
										showArrow={false} />
								</div>
								{
									UI_ELEMENTS_TEXTUAL_KEYS.map(element => {
										return (
											<div className="col-lg-12 p-2" key={element.key}>
												<label className="mb-1">{element.text}</label>
												<input
													type="text"
													className="form-control"
													value={formData.texts[element.key]}
													onChange={(e) => setFormData({ 
														...formData, 
														texts: {
															...formData.texts,
															[`${element.key}`]: e.target.value }
														}
													)}
												/>
											</div>
										);
									})
								}
							</div>
							<div className="text-center">
								<button type="button" className="btn  btn-primary px-4 sbmBtn"
									onClick={() => onSave()}>
									<>{t("Save.label")}</>
								</button>
							</div>
						</Form>
					</div>
				</div>
			</section>
		</>
	);
}

export default withTranslation()(PartnerUIConfig);